import { MortgageWrapperIdName, RootMortgageWrapper } from 'shared/constants/common';
import { ContainerInner } from 'shared/components/ContainerInner';
import { InformationalSeoBlock } from '../InformationalSeoBlock/InformationalSeoBlock';
import {
  FillApplicationButtonMobile,
  useFillApplicationStickyButtons,
  useMobileStickyButtons,
} from '../stickyButtons/FillApplicationButton';
import { useIsDesktop } from '../../hooks/common';
import { ListingContainer } from '../ListingContainer';
import { ControlsContainer } from '../ControlsContainer';

import * as styles from './styles.css';
import { useGetMappedOffers } from '../../hooks/useGetMappedOffers';
import { useSelector } from 'react-redux';
import { selectCalculatorValues } from '../../selectors/landing';
import { CreditInfoModalContainer } from '../CreditInfoModalContainer';
import { selectIsAuthorizedModalOpen } from '../../selectors/landing/selectIsAuthorizedModalOpen';
import { LoginWidgetMicrofrontend } from '../microfrontends/LoginWidgetMicrofrontend';
import { ETestIds } from '../../constants/testIds';
import { useCallback, useState } from 'react';

export function MainContentContainer() {
  const isDesktop = useIsDesktop();
  const [btnRef, setBtnRef] = useState<HTMLElement | null>(null);
  const calculatorValues = useSelector(selectCalculatorValues);
  const { mappedOffers, isFetching } = useGetMappedOffers(calculatorValues);
  const isAuthorizedModalOpen = useSelector(selectIsAuthorizedModalOpen);
  useFillApplicationStickyButtons(mappedOffers.length);
  useMobileStickyButtons(btnRef);

  const handleSetFormRef = useCallback((node: HTMLFormElement | null) => {
    setBtnRef(node);
  }, []);

  return (
    <>
      <div className={styles['root']} id={RootMortgageWrapper}>
        <ContainerInner>
          <div id={MortgageWrapperIdName} className={styles['wrapper']} data-testid={ETestIds.RootMortgageWrapper}>
            <ControlsContainer offersCount={mappedOffers.length} offersIsFetching={isFetching} />
            <ListingContainer mappedOffersList={mappedOffers} offersIsFetching={isFetching} />
          </div>
          <InformationalSeoBlock offersLength={mappedOffers.length} />
        </ContainerInner>
        {!isDesktop && (
          <div className={styles['overlay-background']}>
            <FillApplicationButtonMobile handleOnload={handleSetFormRef} />
          </div>
        )}
      </div>
      <CreditInfoModalContainer />
      {isAuthorizedModalOpen && <LoginWidgetMicrofrontend />}
    </>
  );
}
